import React from "react";
import EarlyAccessButton from "../EarlyAccessButton";
import styles from "./styles.module.scss";

interface ControllableSectionProps {
  onDownloadClick: () => void;
}

/**
 * ControllableSection 组件
 * 展示AI工作流程的实时干预功能
 */
const ControllableSection = ({ onDownloadClick }: ControllableSectionProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        {/* 左侧部分 - 文本内容 */}
        <div className={styles.textContentSection}>
          <div className={styles.textContentInner}>
            <h2 className={styles.mainTitle}>
              Fellou is for <span className={styles.highlight}>Memory.</span>
            </h2>

            <div className={styles.controlComparisonText}>
              <div className={styles.controlComparisonLine}>It remembers everything you do, </div>
              <div className={styles.controlComparisonLine}>so you don't have to.</div>
            </div>

            <EarlyAccessButton onClick={onDownloadClick} />
          </div>
        </div>

        {/* 右侧部分 - 视频展示（替代动画演示） */}
        <div className={styles.videoSection}>
          <div className={styles.videoContainer}>
            <video autoPlay muted loop playsInline className={styles.videoElement}>
              <source
                src="https://fellou.s3.us-west-1.amazonaws.com/videos/website-main-page/Website+main+page+animation/Agentic+Memory.webm"
                type="video/webm"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ControllableSection;
